import React from 'react'
import { useStableAccessor } from '../utils/use-stable-accessor'

export function useTopLevelFormValidation(formElement: HTMLFormElement | string) {
  const getForm = useStableAccessor(formElement)
  const revalidate = React.useCallback(
    (field: string | null) => {
      const formRef = getForm()
      const formElement = typeof formRef === 'string' ? document.getElementById(formRef) : formRef
      const form = formElement && formElement instanceof HTMLFormElement ? formElement : null
      const elements = form ? [...form.elements] : []
      const relevantElements = elements.filter((e) => !field || e.attributes.getNamedItem('name')?.value.startsWith(field))
      relevantElements.forEach((e) => e.dispatchEvent(new Event('change')))
    },
    [getForm]
  )
  return { revalidate }
}
